import { Link } from "react-router-dom";
import { SITE } from "@/site/content";
import { Brand } from "./Nav";
import { SocialRow } from "./Social";

export default function Footer() {
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="wrap">
        <div className="footer__grid">
          <div>
            <Brand />
            <p style={{ marginTop: 12, maxWidth: 300 }}>One record for pricing, approving and signing expansion deals.</p>
          </div>
          <div>
            <h4>Product</h4>
            <a href="/#product">Product</a>
            <a href="/#how-it-works">How it works</a>
            <Link to="/calculators">Calculators</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/changelog">Changelog</Link>
          </div>
          <div>
            <h4>Company</h4>
            <Link to="/about">About</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/pilot">Start a pilot</Link>
            {SITE.email && <a href={`mailto:${SITE.email}`}>{SITE.email}</a>}
            <SocialRow where="footer" withRss />
          </div>
          <div>
            <h4>Security &amp; legal</h4>
            <Link to="/security">Security</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <a href="/.well-known/security.txt">security.txt</a>
          </div>
          <div>
            <h4>Customers</h4>
            {SITE.appUrl && <a href={SITE.appUrl}>Log in</a>}
            {SITE.email ? <a href={`mailto:${SITE.email}?subject=Support`}>Support</a> : <Link to="/contact">Contact</Link>}
            <a href="/sitemap.xml">Sitemap</a>
          </div>
        </div>
        <div className="footer__bottom">
          <span>© {new Date().getFullYear()} {SITE.legalName}. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
